import supabase from "@/features/supabase";
import { ToolsPermissions } from "@/store/services/supabase/types";
import { AuthSession } from "@supabase/supabase-js";
import { jwtDecode } from "jwt-decode";

export type ToolPermissions<T = { enabled: boolean }> = {
  [groupKey: string]: {
    [itemKey: string]: T;
  };
};

export const decodeSessionJwt = (session: AuthSession | null) => {
  if (!session) return null;
  return jwtDecode(session.access_token) as AuthSession["user"];
};

const getCurrentSession = async (): Promise<AuthSession | null> => {
  const { data, error } = await supabase.auth.getSession();
  if (error || !data.session) return null;
  return data.session;
};

const isRole = async (role: string): Promise<boolean> => {
  const session = await getCurrentSession();
  const decoded = decodeSessionJwt(session);
  if (!decoded) return false;

  return decoded?.user_metadata["role"]?.includes(role) ?? false;
};

export const verifyIsOwner = (): Promise<boolean> => isRole("owner");


export const getSessionTools = (session: AuthSession | null): ToolsPermissions => {
  try {
    return decodeSessionJwt(session)?.user_metadata["tools"] ?? {};
  } catch (error) {
    console.error("Failed to read tool permissions from the session JWT", error);
    return {};
  }
};

export const getJwtTools = async (): Promise<ToolsPermissions> => getSessionTools(await getCurrentSession());
